<script lang="ts" setup>
import LightArrowIcon from "@/components/icon/LightArrowIcon.vue";
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";
import { useGlobalUser } from "@/stores/globalUser";
import { useRouter } from "vue-router";
import { onBeforeMount, ref } from "vue";

const user = useGlobalUser();
const router = useRouter();
const loading = ref(false);

onBeforeMount(async () => {
  loading.value = true;
  try {
    await user.refreshUser();
  } finally {
    loading.value = false;
  }
});
</script>
<template>
  <div class="h-full grid grid-rows-[auto_1fr_auto] relative">
    <threads-nav :enable-switch-mate="false" show-back>
      <template #center> {{ $t("Coin.getGoldTicket") }}</template>
    </threads-nav>
    <div v-if="loading" class="flex items-center justify-center">
      <div class="loading"></div>
    </div>
    <div v-else class="flex flex-col p-4 gap-4 overflow-y-auto">
      <div class="flex justify-between items-center bg-neutral p-3 rounded">
        <div class="flex gap-3 items-center text-2xl">
          <i class="iconify mdi--ticket text-my-yellow"></i>
          <span class="text-primary font-bold">{{
            user.goldenTicketAmount
          }}</span>
        </div>
        <div
          class="flex items-center gap-2 cursor-pointer"
          @click="router.push({ name: 'goldTicketBalanceRecord' })"
        >
          {{ $t("Coin.goGetRecordsView") }}
          <light-arrow-icon
            class="transform rotate-180 icon-sm text-base-content/50"
          />
        </div>
      </div>
      <div>
        <article class="prose prose-sm md:prose-base">
          <h3 class="font-normal">{{ $t("Coin.goldTicketIntroTitle") }}</h3>
          <ol v-html="$t('Coin.goldTicketRules')" />
        </article>
      </div>
    </div>
  </div>
</template>
